import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common'

/*
  Generated class for the PostProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class RegisterProvider {
  constructor(public http: HttpClient,
    public commonProvider: CommonProvider) {}

  private _url: string = this.commonProvider.apiUrl + 'api/v1/register';
  private _urlCreateCompany: string = this.commonProvider.apiUrl + 'api/v1/auth';

  
    getFormValues(code): Observable<Response<any>> {
      return this.http.post<Response<any>>(this._url + '/fill', {code: code});
    }

    getQuestions(): Observable<Response<any>> {
      return this.http.get<Response<any>>(this._url + '/questions');
    }

    checkCompanyCode(code): Observable<Response<any>> {
          return this.http.post<Response<any>>(this._url + `/checkcode`, code);
    }

    loadServicePositions(id, code): Observable<Response<any>> {
      return this.http.post<Response<any>>(this._url + `/positions`, {service_id: id, code: code});
}

    createCompany(datas): Observable<Response<any>> {
      return this.http.post<Response<any>>(this._urlCreateCompany + `/createcompany`, datas);
  }

}




// WEBPACK FOOTER //
// ./src/providers/register/register.ts